import { styled } from "@mui/material/styles";
import { palette, shadows, typography } from "src/config/theme";
import { Avatar, Typography, alpha, Box } from "@mui/material";
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import theme from 'src/config/theme';
import ButtonComponent from "src/components/shared/Button";

export const Texts = styled(Typography)({
  color: palette.gery.black,
  ...theme.typography.smallRegular,
});

export const HeaderContainer = styled(Box)({
  backgroundColor: theme.palette.primary.light3,
  color: theme.palette.gery.black,
  ...theme.typography.h4,
  border: `1px solid ${alpha(theme.palette.primary.light1)}`,
  padding: '20px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '59px',
});

export const HiddenComponent = styled(Box)({
  height: '76px',
  display: 'flex',
  gap: '22px',
  justifyContent: 'space-between'
});

export const AddAppointmentContainer = styled(Box)(({ isExpanded, theme }) => ({
  backgroundColor: theme.palette.gery.white,
  width: '350px',
  // height: isExpanded ? '596px' : '496px',
  padding: '24px 20px 28px 20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '18px',
  transition: 'height 0.3s ease-in-out',
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  '-ms-overflow-style': 'none',
  'scrollbar-width': 'none',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: '320px',
  },
  [theme.breakpoints.down('xs')]: {
    width: '100%',
    maxWidth: '280px',
  },
}));

export const AddPatientContainer = styled(Box)(({ isExpanded, theme }) => ({
  backgroundColor: theme.palette.gery.white,
  width: '350px',
  height: '350px',
  padding: '24px 20px 28px 20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '18px',
  transition: 'height 0.3s ease-in-out',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: '320px',
  },
  [theme.breakpoints.down('xs')]: {
    width: '100%',
    maxWidth: '280px',
  },
}));

export const AddTaskContainer = styled(Box)(({ isExpanded, theme }) => ({
  backgroundColor: theme.palette.gery.white,
  width: '350px',
  // height: isExpanded ? '596px' : '496px',
  padding: '24px 20px 28px 20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '18px',
  transition: 'height 0.3s ease-in-out',
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  '-ms-overflow-style': 'none',
  'scrollbar-width': 'none',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: '320px',
  },
  [theme.breakpoints.down('xs')]: {
    width: '100%',
    maxWidth: '280px',
  },
}));

export const AddBillingContainer = styled(Box)(({ isExpanded, theme }) => ({
  backgroundColor: theme.palette.gery.white,
  width: '350px',
  // height: isExpanded ? '438px' : '438px',
  padding: '20px 16px 24px 16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '18px',
  transition: 'height 0.3s ease-in-out',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: '320px',
  },
  [theme.breakpoints.down('xs')]: {
    width: '100%',
    maxWidth: '280px',
  },
}));

export const Component1 = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  // width: '430px',
  height: '65px',
});

export const Component2 = styled(Box)({
  height: '65px',
  display: 'flex',
  gap: '14px',
  justifyContent: 'space-between'
});

export const InnerComponent = styled(Box)({
  display: 'flex',
  gap: '4px',
  flexDirection: 'column',
  height: '65px',
  width: '204px',
})

export const Component3 = styled(Box)({
  height: '65px',
  display: 'flex',
  gap: '14px',
  justifyContent: 'space-between'
});

export const Component4 = styled(Box)({
  height: '121px',
  display: 'flex',
  gap: '4px',
  flexDirection: 'column'
});

export const ButtonContainer = styled(Box)({
  height: '80px',
  padding: '24px 20px',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '16px',
  border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
});

export const StyledButton = styled(ButtonComponent)({
  ...theme.typography.h6,
  width: '92px',
  height: '40px',
  borderRadius: '12px',
  padding: '10px 18px',
  backgroundColor: theme.palette.primary.main,
  boxShadow: theme.shadows[1],
  border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
  color: theme.palette.gery.white,
  '&:hover': {
    color: theme.palette.primary.main,
  },
});

export const ThreeButtonContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  margin: '16px 16px 0px 16px',
  gap: '10px',

})
